import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ArrowDownIcon } from 'lucide-react';
interface Position {
  x: number;
  y: number;
}
const NOTES = [{
  id: 1,
  color: '#C4B5FD',
  text: "What breaks first if user volume 10x's in the next client onboarding session?",
  author: 'product',
  rotation: -2,
  showMobile: true
}, {
  id: 2,
  color: '#7DDDD9',
  text: 'can you make it.... pop... 🤠',
  author: 'you',
  rotation: 1.5,
  showMobile: true
}, {
  id: 3,
  color: '#F9A8D4',
  text: 'feature or bug? workarounds? where can we compromise to ship asap?',
  author: 'product',
  rotation: -1,
  showMobile: false
}, {
  id: 4,
  color: '#FCD5A0',
  text: 'try prototyping then we vote and ship!',
  author: 'design',
  rotation: 2,
  showMobile: true
}, {
  id: 5,
  color: '#BBF7D0',
  text: 'Are we designing for low bandwidth environments? what is our failsafe for this feature if wifi is down?',
  author: 'you',
  rotation: -1.5,
  showMobile: false
}, {
  id: 6,
  color: '#FEF08A',
  text: 'Is this SKU logic configurable or hardcoded?',
  author: 'dev',
  rotation: 1,
  showMobile: false
}];
const NOTE_SIZE = 190;
const LS_KEY = 'golaunch-hero-positions';
// ── Hero stickers ─────────────────────────────────────────────────────────
const HERO_STICKERS = [{
  id: 0,
  src: 'https://cdn.magicpatterns.com/uploads/fZygjXoSouC87yonnQ3cKM/image.png',
  w: 118,
  h: 90,
  rotation: 5
}, {
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/1iC9VMXdgBPGCSzouBM9Dj/image.png',
  w: 118,
  h: 72,
  rotation: -4
}, {
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/8w9znNHKp5VKwgGQzAAQmv/image.png',
  w: 78,
  h: 90,
  rotation: 8
}, {
  id: 3,
  src: 'https://cdn.magicpatterns.com/uploads/ftjRvM3M4WzSfmTcCpPPtn/image.png',
  w: 92,
  h: 88,
  rotation: -6
}, {
  id: 4,
  src: 'https://cdn.magicpatterns.com/uploads/cfEfoNEWsSeY92XvAYBcSf/image_280.png',
  w: 88,
  h: 88,
  rotation: 7
}, {
  id: 5,
  src: 'https://cdn.magicpatterns.com/uploads/4xLi9CdY4nvHP3rDrFVShF/image_278.png',
  w: 85,
  h: 85,
  rotation: -8
}];
// ── Combined spawn pool: Hero stickers + About stickers + extras ──────────
const SPAWN_POOL: {
  src: string;
  w: number;
  h: number;
}[] = [
// Hero stickers
...HERO_STICKERS.map(s => ({
  src: s.src,
  w: s.w,
  h: s.h
})),
// About stickers (color palette removed)
{
  src: 'https://cdn.magicpatterns.com/uploads/aSSN5r6FKeKAbPRYNBan8J/image_274.png',
  w: 80,
  h: 80
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rrfSzBNokG14ovpUK9u4hG/image_275.png',
  w: 95,
  h: 95
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3GSvRgSePdEvGatoAnT4mE/image_276.png',
  w: 100,
  h: 100
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7HLGZG9mz7AbGsG1SxoHct/image_277.png',
  w: 85,
  h: 85
}, {
  src: 'https://cdn.magicpatterns.com/uploads/f7zBiriGL9mLxi2oR5aW5K/image_281.png',
  w: 92,
  h: 92
}, {
  src: 'https://cdn.magicpatterns.com/uploads/u4mhrPp5twg46HbcEJboVW/image_282.png',
  w: 105,
  h: 105
}, {
  src: 'https://cdn.magicpatterns.com/uploads/x2NieDLdgGtbev48WRC1kX/image_283.png',
  w: 82,
  h: 82
},
// Extra stickers
{
  src: 'https://cdn.magicpatterns.com/uploads/wgLJNrKyEAy1FM95xBSPX6/image.png',
  w: 100,
  h: 88
}, {
  src: 'https://cdn.magicpatterns.com/uploads/snZGmp3uEbTmAc6ESSBf3f/image.png',
  w: 80,
  h: 90
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uqyZ8b6k57pFppbQW3DQXY/image.png',
  w: 100,
  h: 88
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4pbX3nyU4eo6JtAQLFGK8z/image.png',
  w: 130,
  h: 58
},
// New stickers
{
  src: 'https://cdn.magicpatterns.com/uploads/xzKrsBH2wKujJH9qLBMbQA/image.png',
  w: 90,
  h: 80
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3e776NLCA11v3TLFY3g45n/image.png',
  w: 88,
  h: 82
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rnQsgqDN6aPSmg4H8ymSUp/image.png',
  w: 105,
  h: 75
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2YQ6SfCjUTgJQej6Qw4Vi6/image.png',
  w: 88,
  h: 88
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1Ji5rvtDKBv2tA6W49Dkob/image.png',
  w: 82,
  h: 90
}];
/** Fisher-Yates shuffle — returns a new shuffled array of indices */
function shuffleIndices(length: number): number[] {
  const arr = Array.from({
    length
  }, (_, i) => i);
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
interface SpawnedSticker {
  id: number;
  stickerIndex: number;
  src: string;
  w: number;
  h: number;
  rotation: number;
}
function getDefaultStickerPositions(vw: number, vh: number): Position[] {
  const isMobile = vw < 768;
  if (isMobile) {
    // Mobile: 6 stickers envelope around the content, framing the hero
    return [
    // Sticker 0 (typewriter) — top-right, partially off right edge
    {
      x: vw - 110,
      y: Math.round(vh * 0.08)
    },
    // Sticker 1 (phone wireframe) — top-left, partially off left edge
    {
      x: -28,
      y: Math.round(vh * 0.1)
    },
    // Sticker 2 — mid-right, partially off right edge
    {
      x: vw - 50,
      y: Math.round(vh * 0.36)
    },
    // Sticker 3 — mid-left edge
    {
      x: -20,
      y: Math.round(vh * 0.34)
    },
    // Sticker 4 — bottom-right, near CTA area
    {
      x: vw - 65,
      y: Math.round(vh * 0.64)
    },
    // Sticker 5 — bottom-left, near CTA area
    {
      x: -15,
      y: Math.round(vh * 0.68)
    }];
  }
  const leftX = 32;
  const rightX = vw - 160;
  return [{
    x: rightX - 10,
    y: Math.round(vh * 0.22)
  }, {
    x: leftX + 8,
    y: Math.round(vh * 0.26)
  }, {
    x: rightX + 20,
    y: Math.round(vh * 0.48)
  }, {
    x: leftX,
    y: Math.round(vh * 0.54)
  }, {
    x: rightX,
    y: Math.round(vh * 0.7)
  }, {
    x: leftX + 12,
    y: Math.round(vh * 0.76)
  }];
}
/**
 * Compute default positions so notes frame the center content.
 * Left column: notes 0, 3, 5  |  Right column: notes 1, 2, 4
 */
function getDefaultPositions(vw: number, vh: number): Position[] {
  const leftX = 28;
  const rightX = vw - NOTE_SIZE - 28;
  const mobileLeftX = -30;
  const mobileRightX = vw - NOTE_SIZE + 30;
  const isMobile = vw < 768;
  if (isMobile) {
    return [{
      x: mobileLeftX,
      y: Math.round(vh * 0.18)
    }, {
      x: mobileRightX,
      y: Math.round(vh * 0.15)
    }, {
      x: mobileRightX,
      y: Math.round(vh * 0.38)
    }, {
      x: mobileLeftX,
      y: Math.round(vh * 0.52)
    }, {
      x: mobileRightX,
      y: Math.round(vh * 0.62)
    }, {
      x: mobileLeftX,
      y: Math.round(vh * 0.72)
    }];
  }
  // Slight x-offsets to break the straight-line feel
  return [{
    x: leftX + 10,
    y: Math.round(vh * 0.08)
  }, {
    x: rightX - 18,
    y: Math.round(vh * 0.06)
  }, {
    x: rightX - 120,
    y: Math.round(vh * 0.34)
  }, {
    x: leftX + 110,
    y: Math.round(vh * 0.38)
  }, {
    x: rightX - 12,
    y: Math.round(vh * 0.62)
  }, {
    x: leftX + 20,
    y: Math.round(vh * 0.72)
  } // 5 yellow — bottom-left
  ];
}
function loadSavedPositions(): Position[] | null {
  return null;
}
function savePositions(_positions: Position[]) {
  // No-op: positions reset on every page load
}
export function Hero() {
  const sectionRef = useRef<HTMLElement>(null);
  const [positions, setPositions] = useState<Position[]>(() => {
    const saved = loadSavedPositions();
    if (saved) return saved;
    const vw = typeof window !== 'undefined' ? window.innerWidth : 1280;
    const vh = typeof window !== 'undefined' ? window.innerHeight : 900;
    return getDefaultPositions(vw, vh);
  });
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [topZ, setTopZ] = useState(NOTES.length);
  const [zOrders, setZOrders] = useState(NOTES.map((_, i) => i + 1));
  const [cursorPos, setCursorPos] = useState<Position>({
    x: -999,
    y: -999
  });
  const [isOnSection, setIsOnSection] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(typeof window !== 'undefined' ? window.innerWidth >= 1024 : true);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);
  // ── Sticker state ────────────────────────────────────────────────────────
  const [stickerPositions, setStickerPositions] = useState<Position[]>(() => {
    const vw = typeof window !== 'undefined' ? window.innerWidth : 1280;
    const vh = typeof window !== 'undefined' ? window.innerHeight : 900;
    return getDefaultStickerPositions(vw, vh);
  });
  const [stickerTopZ, setStickerTopZ] = useState(50);
  const [stickerZ, setStickerZ] = useState(HERO_STICKERS.map((_, i) => i + 41));
  // ── Spawned stickers state ───────────────────────────────────────────────
  const [spawnedStickers, setSpawnedStickers] = useState<SpawnedSticker[]>([]);
  const nextSpawnId = useRef(0);
  // Round-robin shuffle queue: ensures every sticker is used before repeats
  const spawnQueueRef = useRef<number[]>(shuffleIndices(SPAWN_POOL.length));
  const stickerDragRef = useRef<{
    index: number;
    startMouseX: number;
    startMouseY: number;
    startCardX: number;
    startCardY: number;
  } | null>(null);
  const stickerPosRef = useRef(stickerPositions);
  stickerPosRef.current = stickerPositions;
  const dragRef = useRef<{
    index: number;
    startMouseX: number;
    startMouseY: number;
    startCardX: number;
    startCardY: number;
  } | null>(null);
  const positionsRef = useRef(positions);
  positionsRef.current = positions;
  // ── Spawn sticker handler ────────────────────────────────────────────────
  const handleSpawnSticker = useCallback(() => {
    const section = sectionRef.current;
    if (!section) return;
    // Pull next index from the shuffle queue; reshuffle when exhausted
    if (spawnQueueRef.current.length === 0) {
      spawnQueueRef.current = shuffleIndices(SPAWN_POOL.length);
    }
    const poolIndex = spawnQueueRef.current.pop()!;
    const template = SPAWN_POOL[poolIndex];
    const sectionW = section.offsetWidth;
    const sectionH = section.offsetHeight;
    const isMobile = sectionW < 768;
    let x: number;
    let y: number;
    if (isMobile) {
      // On mobile, spawn around the edges to avoid covering center text
      // Pick a random edge zone: left, right, top, or bottom
      const zone = Math.floor(Math.random() * 4);
      switch (zone) {
        case 0:
          // left edge
          x = Math.round(Math.random() * sectionW * 0.2);
          y = Math.round(sectionH * 0.1 + Math.random() * sectionH * 0.8);
          break;
        case 1:
          // right edge
          x = Math.round(sectionW * 0.75 + Math.random() * sectionW * 0.2);
          y = Math.round(sectionH * 0.1 + Math.random() * sectionH * 0.8);
          break;
        case 2:
          // top edge
          x = Math.round(sectionW * 0.05 + Math.random() * sectionW * 0.9);
          y = Math.round(Math.random() * sectionH * 0.22);
          break;
        default:
          // bottom edge
          x = Math.round(sectionW * 0.05 + Math.random() * sectionW * 0.9);
          y = Math.round(sectionH * 0.78 + Math.random() * sectionH * 0.18);
          break;
      }
    } else {
      // Desktop: spread across 10%-90%
      x = Math.round(sectionW * 0.1 + Math.random() * sectionW * 0.8);
      y = Math.round(sectionH * 0.1 + Math.random() * sectionH * 0.8);
    }
    // Random rotation between -12 and 12
    const rotation = Math.round((Math.random() - 0.5) * 24);
    const newSticker: SpawnedSticker = {
      id: nextSpawnId.current++,
      stickerIndex: poolIndex,
      src: template.src,
      w: template.w,
      h: template.h,
      rotation
    };
    // Append position
    setStickerPositions(prev => [...prev, {
      x,
      y
    }]);
    // Append z-index
    const newZ = stickerTopZ + 1;
    setStickerTopZ(newZ);
    setStickerZ(prev => [...prev, newZ]);
    // Append sticker data
    setSpawnedStickers(prev => [...prev, newSticker]);
  }, [stickerTopZ]);
  // Recalculate defaults on resize (only if no saved positions)
  useEffect(() => {
    const onResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
      setIsMobile(window.innerWidth < 768);
      if (!loadSavedPositions()) {
        setPositions(getDefaultPositions(window.innerWidth, window.innerHeight));
      }
      setStickerPositions(getDefaultStickerPositions(window.innerWidth, window.innerHeight));
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  // Cursor tracking
  const handleSectionMouseMove = useCallback((e: MouseEvent) => {
    const el = sectionRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setCursorPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  }, []);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    el.addEventListener('mousemove', handleSectionMouseMove);
    el.addEventListener('mouseenter', () => setIsOnSection(true));
    el.addEventListener('mouseleave', () => {
      setIsOnSection(false);
      setCursorPos({
        x: -999,
        y: -999
      });
    });
    return () => el.removeEventListener('mousemove', handleSectionMouseMove);
  }, [handleSectionMouseMove]);
  // Drag handlers
  const handleMouseDown = useCallback((e: React.MouseEvent, index: number) => {
    e.preventDefault();
    e.stopPropagation();
    const newZ = topZ + 1;
    setTopZ(newZ);
    setZOrders(prev => {
      const next = [...prev];
      next[index] = newZ;
      return next;
    });
    dragRef.current = {
      index,
      startMouseX: e.clientX,
      startMouseY: e.clientY,
      startCardX: positionsRef.current[index].x,
      startCardY: positionsRef.current[index].y
    };
    setActiveIndex(index);
  }, [topZ]);
  const handleTouchStart = useCallback((e: React.TouchEvent, index: number) => {
    const touch = e.touches[0];
    const newZ = topZ + 1;
    setTopZ(newZ);
    setZOrders(prev => {
      const next = [...prev];
      next[index] = newZ;
      return next;
    });
    dragRef.current = {
      index,
      startMouseX: touch.clientX,
      startMouseY: touch.clientY,
      startCardX: positionsRef.current[index].x,
      startCardY: positionsRef.current[index].y
    };
    setActiveIndex(index);
  }, [topZ]);
  const handleStickerMouseDown = useCallback((e: React.MouseEvent, index: number) => {
    e.preventDefault();
    e.stopPropagation();
    const newZ = stickerTopZ + 1;
    setStickerTopZ(newZ);
    setStickerZ(prev => {
      const next = [...prev];
      next[index] = newZ;
      return next;
    });
    stickerDragRef.current = {
      index,
      startMouseX: e.clientX,
      startMouseY: e.clientY,
      startCardX: stickerPosRef.current[index].x,
      startCardY: stickerPosRef.current[index].y
    };
  }, [stickerTopZ]);
  // ... existing useEffect for mouse/touch move unchanged ...
  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      if (dragRef.current) {
        const {
          index,
          startMouseX,
          startMouseY,
          startCardX,
          startCardY
        } = dragRef.current;
        setPositions(prev => {
          const next = [...prev];
          next[index] = {
            x: startCardX + (e.clientX - startMouseX),
            y: startCardY + (e.clientY - startMouseY)
          };
          return next;
        });
      }
      if (stickerDragRef.current) {
        const {
          index,
          startMouseX,
          startMouseY,
          startCardX,
          startCardY
        } = stickerDragRef.current;
        const newX = startCardX + (e.clientX - startMouseX);
        const newY = startCardY + (e.clientY - startMouseY);
        setStickerPositions(prev => {
          const next = [...prev];
          next[index] = {
            x: newX,
            y: newY
          };
          return next;
        });
      }
    };
    const onTouchMove = (e: TouchEvent) => {
      if (!dragRef.current && !stickerDragRef.current) return;
      e.preventDefault();
      const touch = e.touches[0];
      if (dragRef.current) {
        const {
          index,
          startMouseX,
          startMouseY,
          startCardX,
          startCardY
        } = dragRef.current;
        setPositions(prev => {
          const next = [...prev];
          next[index] = {
            x: startCardX + (touch.clientX - startMouseX),
            y: startCardY + (touch.clientY - startMouseY)
          };
          return next;
        });
      }
      if (stickerDragRef.current) {
        const {
          index,
          startMouseX,
          startMouseY,
          startCardX,
          startCardY
        } = stickerDragRef.current;
        const newX = startCardX + (touch.clientX - startMouseX);
        const newY = startCardY + (touch.clientY - startMouseY);
        setStickerPositions(prev => {
          const next = [...prev];
          next[index] = {
            x: newX,
            y: newY
          };
          return next;
        });
      }
    };
    const onEnd = () => {
      if (dragRef.current !== null) {
        savePositions(positionsRef.current);
      }
      dragRef.current = null;
      stickerDragRef.current = null;
      setActiveIndex(null);
    };
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onEnd);
    window.addEventListener('touchmove', onTouchMove, {
      passive: false
    });
    window.addEventListener('touchend', onEnd);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onEnd);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onEnd);
    };
  }, []);
  return <section ref={sectionRef} className="relative min-h-screen w-full flex flex-col overflow-hidden" style={{
    background: '#EDECEA',
    backgroundImage: 'radial-gradient(circle, #B8B5B0 1px, transparent 1px)',
    backgroundSize: '24px 24px',
    cursor: isOnSection && activeIndex === null ? 'none' : activeIndex !== null ? 'grabbing' : 'auto',
    userSelect: 'none',
    WebkitUserSelect: 'none'
  }} data-id="element-61">
      {/* Spawn animation keyframes */}
      <style data-id="element-62">{`
        @keyframes stickerPop {
          0% { transform: scale(0) rotate(var(--spawn-rotation)); opacity: 0; }
          60% { transform: scale(1.15) rotate(var(--spawn-rotation)); opacity: 1; }
          100% { transform: scale(1) rotate(var(--spawn-rotation)); opacity: 1; }
        }
      `}</style>

      {/* Draggable post-its */}
      {NOTES.map((note, i) => {
      const pos = positions[i];
      const isDragging = activeIndex === i;
      return <div key={note.id} onMouseDown={e => handleMouseDown(e, i)} onTouchStart={e => handleTouchStart(e, i)} style={{
        position: 'absolute',
        left: pos.x,
        top: pos.y,
        width: NOTE_SIZE,
        height: NOTE_SIZE,
        background: note.color,
        borderRadius: 4,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transform: `rotate(${note.rotation}deg) scale(${isDragging ? 1.05 : 1})`,
        boxShadow: isDragging ? '0 20px 48px rgba(0,0,0,0.20)' : '0 4px 16px rgba(0,0,0,0.10)',
        cursor: isDragging ? 'grabbing' : 'grab',
        zIndex: Math.min(zOrders[i] + 30, 40),
        transition: isDragging ? 'box-shadow 0.15s, transform 0.1s' : 'box-shadow 0.2s, transform 0.2s',
        touchAction: 'none',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        visibility: isLargeScreen ? 'visible' : 'hidden',
        pointerEvents: isLargeScreen ? 'auto' : 'none'
      }} data-id="element-63">
            <p style={{
          fontSize: 13,
          fontWeight: 500,
          color: '#1a1a2e',
          lineHeight: 1.5,
          margin: 0
        }} data-id="element-64">
              {note.text}
            </p>
            <p style={{
          fontSize: 11,
          color: '#1a1a2e',
          opacity: 0.5,
          margin: 0,
          fontWeight: 300,
          fontFamily: "'Aspekta', sans-serif",
          letterSpacing: '0.04em'
        }} data-id="element-65">
              {note.author}
            </p>
          </div>;
    })}

      {/* Draggable stickers — original set */}
      {HERO_STICKERS.map((sticker, i) => {
      const mobileScale = isMobile ? 1.35 : 1;
      return <img key={sticker.id} src={sticker.src} alt="" draggable={false} onMouseDown={e => handleStickerMouseDown(e, i)} onTouchStart={e => {
        e.preventDefault();
        e.stopPropagation();
        const touch = e.touches[0];
        const newZ = stickerTopZ + 1;
        setStickerTopZ(newZ);
        setStickerZ(prev => {
          const next = [...prev];
          next[i] = newZ;
          return next;
        });
        stickerDragRef.current = {
          index: i,
          startMouseX: touch.clientX,
          startMouseY: touch.clientY,
          startCardX: stickerPosRef.current[i].x,
          startCardY: stickerPosRef.current[i].y
        };
      }} style={{
        position: 'absolute',
        left: stickerPositions[i]?.x ?? 0,
        top: stickerPositions[i]?.y ?? 0,
        width: sticker.w * mobileScale,
        height: sticker.h * mobileScale,
        objectFit: 'contain',
        transform: `rotate(${sticker.rotation}deg)`,
        cursor: 'grab',
        userSelect: 'none',
        zIndex: Math.min(stickerZ[i], 49),
        filter: 'drop-shadow(0 3px 10px rgba(0,0,0,0.16))',
        touchAction: 'none'
      }} data-id="element-66" />;
    })}

      {/* Spawned stickers */}
      {spawnedStickers.map((sticker, spawnedIndex) => {
      const globalIndex = HERO_STICKERS.length + spawnedIndex;
      const pos = stickerPositions[globalIndex];
      if (!pos) return null;
      return <img key={`spawned-${sticker.id}`} src={sticker.src} alt="" draggable={false} onMouseDown={e => handleStickerMouseDown(e, globalIndex)} onTouchStart={e => {
        e.preventDefault();
        e.stopPropagation();
        const touch = e.touches[0];
        const newZ = stickerTopZ + 1;
        setStickerTopZ(newZ);
        setStickerZ(prev => {
          const next = [...prev];
          next[globalIndex] = newZ;
          return next;
        });
        stickerDragRef.current = {
          index: globalIndex,
          startMouseX: touch.clientX,
          startMouseY: touch.clientY,
          startCardX: stickerPosRef.current[globalIndex].x,
          startCardY: stickerPosRef.current[globalIndex].y
        };
      }} style={{
        position: 'absolute',
        left: pos.x,
        top: pos.y,
        width: sticker.w,
        height: sticker.h,
        objectFit: 'contain',
        cursor: 'grab',
        userSelect: 'none',
        zIndex: Math.min(stickerZ[globalIndex] ?? 50, 49),
        filter: 'drop-shadow(0 3px 10px rgba(0,0,0,0.16))',
        touchAction: 'none',
        // @ts-ignore CSS custom property for animation
        '--spawn-rotation': `${sticker.rotation}deg`,
        animation: 'stickerPop 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) both',
        transform: `rotate(${sticker.rotation}deg)`
      } as React.CSSProperties} data-id="element-67" />;
    })}

      {/* Main content */}
      <div className="relative flex-1 flex flex-col items-center justify-center px-6 md:px-12 pt-24 md:pt-24 pb-4 text-center" style={{
      zIndex: 20,
      pointerEvents: 'none'
    }} data-id="element-68">
        <h1 className="font-[250] text-[clamp(3rem,5.5vw,5rem)] leading-[1.0] tracking-[-0.03em] mb-6 animate-fade-up delay-200" style={{
        color: 'var(--fg)',
        maxWidth: '14ch'
      }} data-id="element-69">
          Good ideas
          <br data-id="element-70" />
          don't wait.
        </h1>
        <p className="text-base md:text-lg leading-relaxed mb-10 animate-fade-up delay-300" style={{
        color: 'var(--muted)',
        maxWidth: '44ch',
        fontWeight: 400
      }} data-id="element-71">
          GoLaunch is a product design and development studio building brands,
          websites, and early-stage products from concept to capital.
        </p>
        <div className="flex items-center gap-3 animate-fade-up delay-400" style={{
        pointerEvents: 'auto'
      }} data-id="element-72">
          <a href="#work" className="font-medium text-sm px-6 py-3 rounded-full transition-colors duration-200" style={{
          background: 'var(--accent)',
          color: '#fff'
        }} onMouseEnter={e => e.currentTarget.style.background = '#A8421A'} onMouseLeave={e => e.currentTarget.style.background = 'var(--accent)'} data-id="element-73">
            See our work
          </a>

          {/* Skeuomorphic + button */}
          <button onClick={handleSpawnSticker} aria-label="Add sticker" style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(180deg, #F5F4F2 0%, #E8E6E3 100%)',
          boxShadow: `
                0 2px 4px rgba(0,0,0,0.12),
                0 4px 8px rgba(0,0,0,0.08),
                inset 0 1px 0 rgba(255,255,255,0.7),
                inset 0 -1px 0 rgba(0,0,0,0.05)
              `,
          transition: 'all 0.15s ease'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = 'linear-gradient(180deg, #FAF9F7 0%, #EDEBE8 100%)';
          e.currentTarget.style.boxShadow = `
                0 3px 6px rgba(0,0,0,0.14),
                0 6px 12px rgba(0,0,0,0.10),
                inset 0 1px 0 rgba(255,255,255,0.8),
                inset 0 -1px 0 rgba(0,0,0,0.05)
              `;
        }} onMouseLeave={e => {
          e.currentTarget.style.background = 'linear-gradient(180deg, #F5F4F2 0%, #E8E6E3 100%)';
          e.currentTarget.style.boxShadow = `
                0 2px 4px rgba(0,0,0,0.12),
                0 4px 8px rgba(0,0,0,0.08),
                inset 0 1px 0 rgba(255,255,255,0.7),
                inset 0 -1px 0 rgba(0,0,0,0.05)
              `;
          e.currentTarget.style.transform = 'translateY(0)';
        }} onMouseDown={e => {
          e.currentTarget.style.transform = 'translateY(1px)';
          e.currentTarget.style.boxShadow = `
                0 1px 2px rgba(0,0,0,0.12),
                0 2px 4px rgba(0,0,0,0.08),
                inset 0 1px 0 rgba(255,255,255,0.5),
                inset 0 -1px 0 rgba(0,0,0,0.08)
              `;
        }} onMouseUp={e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = `
                0 3px 6px rgba(0,0,0,0.14),
                0 6px 12px rgba(0,0,0,0.10),
                inset 0 1px 0 rgba(255,255,255,0.8),
                inset 0 -1px 0 rgba(0,0,0,0.05)
              `;
        }} data-id="element-74">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{
            display: 'block'
          }} data-id="element-75">
              <path d="M8 2V14M2 8H14" stroke="#7A7875" strokeWidth="2" strokeLinecap="round" data-id="element-76" />
            </svg>
          </button>
        </div>
      </div>

      {/* Scroll indicator — raised to be visible before the fold */}
      <div className="relative z-20 flex items-center justify-center gap-2 animate-fade-up delay-500" style={{
      color: 'var(--muted)',
      pointerEvents: 'none',
      paddingBottom: '1.5rem'
    }} data-id="element-77">
        <span className="text-xs" data-id="element-78">Scroll to explore</span>
        <span className="animate-bob" data-id="element-79">
          <ArrowDownIcon size={12} data-id="element-80" />
        </span>
      </div>

      {/* Figma-style "you" cursor */}
      {isOnSection && activeIndex === null && <div className="pointer-events-none absolute" style={{
      left: cursorPos.x,
      top: cursorPos.y,
      zIndex: 100
    }} data-id="element-81">
          <svg width="20" height="24" viewBox="0 0 20 24" fill="none" style={{
        display: 'block',
        filter: 'drop-shadow(0 1px 4px rgba(0,0,0,0.18))'
      }} data-id="element-82">
            <path d="M3 2L17 11.5L10.5 13.5L7.5 21L3 2Z" fill="#5B6FE6" stroke="white" strokeWidth="1.5" strokeLinejoin="round" data-id="element-83" />
          </svg>
          <div style={{
        position: 'absolute',
        top: 18,
        left: 14,
        background: '#5B6FE6',
        color: '#fff',
        fontSize: '11px',
        fontWeight: 500,
        fontFamily: "'Aspekta', sans-serif",
        padding: '2px 7px 3px',
        borderRadius: '0 6px 6px 6px',
        whiteSpace: 'nowrap',
        boxShadow: '0 1px 6px rgba(0,0,0,0.15)',
        letterSpacing: '0.01em'
      }} data-id="element-84">
            you
          </div>
        </div>}
    </section>;
}